// /devices API
//  - GET  /devices/                   -> list all devices
//  - GET  /devices/:deviceType        -> list devices of a type
//  - POST /devices/test-device/:id    -> play test sound on device

export class DevicesAPI {
  /**
   * @param {import('../httpClient').HttpClient} http
   * @param {{ wsURL?: string }} [opts]
   */
  constructor(http, opts = {}) {
    this.http = http;
    this.wsURL = opts.wsURL || "";
  }

  listAll() {
    return this.http.get("/devices/", { noCache: true });
  }

  listByType(deviceType) {
    return this.http.get(`/devices/${encodeURIComponent(deviceType)}`, { noCache: true });
  }

  testDevice(deviceHexId) {
    return this.http.post(`/devices/test-device/${encodeURIComponent(deviceHexId)}`);
  }

  // Force server-side refresh of device cache
  refresh() {
    return this.http.post("/devices/refresh");
  }

  /**
   * Build the WebSocket URL for streaming dBFS readings of a device.
   * Returns null if no wsURL was configured.
   */
  levelStreamURL(deviceHexId) {
    if (!this.wsURL) return null;
    return `${this.wsURL}/devices/level/${encodeURIComponent(deviceHexId)}`;
  }
}
